import React from "react";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

function DynamicSnackbar(props) {
  const { open, severity, message, url, handleClose } = props;
  var sendMessage = message;
  if (url != null) {
    sendMessage = <a href={url}> {message} </a>;
  }

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={3000}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MuiAlert onClose={handleClose} variant="filled" severity={severity}>
        {severity === "error"
          ? "An Error has occured. See Console."
          : sendMessage}
      </MuiAlert>
    </Snackbar>
  );
}

export default DynamicSnackbar;
